export const THEMES = {
  default: {
    id: 'default',
    label: 'Standard Jonny’s Towing',
    eyebrow: 'Richmond’s local towing team',
    title: 'Driven by care. Ready when the road is not.',
    description: 'Fast, professional towing and roadside assistance from real local people who understand that a breakdown can ruin your day.',
    image: '/images/rolls-royce-flatbed.webp',
    className: 'theme-default',
    accentLabel: 'Call or text HELP',
    decorations: ['spark', 'road'],
  },
  valentines: {
    id: 'valentines',
    label: 'Valentine’s Day',
    eyebrow: 'Roadside help with a whole lot of heart',
    title: 'Car trouble is not romantic. Being rescued with care absolutely can be.',
    description: 'This Valentine’s season, Richmond gets professional towing, patient communication and the bright-pink details that have always been part of our love language.',
    image: '/images/rolls-royce-flatbed.webp',
    className: 'theme-valentines',
    accentLabel: 'Your roadside sweetheart',
    decorations: ['hearts', 'sparkles'],
    seasonalMessage: {
      icon: '♥',
      title: 'Sending a little love to Richmond’s roads.',
      text: 'Whether your battery gave up, your tire went flat or your vehicle simply will not cooperate, we will show up with patience, professionalism and heart.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/valentines.mp3', title: 'Heart on the Road', accent: '#ff6aa9' },
  },
  'st-patricks': {
    id: 'st-patricks',
    label: 'St. Patrick’s Day',
    eyebrow: 'A little luck for the road ahead',
    title: 'When roadside luck runs out, Richmond still has Jonny’s.',
    description: 'No four-leaf clover required—just local towing, clear communication and a capable truck arriving when your plans have gone sideways.',
    image: '/images/flatbed-sunset.webp',
    className: 'theme-st-patricks',
    accentLabel: 'Your local lucky break',
    decorations: ['clovers', 'gold', 'sparkles'],
    seasonalMessage: {
      icon: '☘',
      title: 'Good luck is nice. Reliable roadside help is better.',
      text: 'We hope your St. Patrick’s Day is full of green lights and easy miles. When it is not, give Jonny’s a call.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/st-patricks.mp3', title: 'A Lucky Way Home', accent: '#55e28d' },
  },
  easter: {
    id: 'easter',
    label: 'Easter',
    eyebrow: 'Hope, renewal and the road ahead',
    title: 'Wishing Richmond a joyful Easter and brighter journeys ahead.',
    description: 'May this Easter season bring hope, peace and new beginnings. When your vehicle cannot continue the journey, Jonny’s Towing is ready to help with care.',
    image: '/images/lions-gate.webp',
    className: 'theme-easter',
    accentLabel: 'Hope for the road ahead',
    decorations: ['eggs', 'spring', 'sunrise', 'sparkles'],
    seasonalMessage: {
      icon: '✦',
      title: 'A season of hope and fresh starts.',
      text: 'From our family to yours, happy Easter. We remain available when an unexpected roadside problem interrupts your holiday plans.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/easter.mp3', title: 'Morning Hope', accent: '#f6c86f' },
  },
  'canada-day': {
    id: 'canada-day',
    label: 'Canada Day',
    eyebrow: 'Proudly local. Proudly Canadian.',
    title: 'Red, white and roadside-ready for Canada Day.',
    description: 'Celebrating the community we call home with professional local towing, Canadian pride and the unmistakable black-and-pink Jonny’s fleet.',
    image: '/images/flatbed-sunset.webp',
    className: 'theme-canada',
    accentLabel: 'Local service, Canadian pride',
    decorations: ['maple', 'ribbons', 'sparkles'],
    seasonalMessage: {
      icon: '🍁',
      title: 'Happy Canada Day, Richmond.',
      text: 'Enjoy the celebrations, plan a safe ride home and remember that Jonny’s is here when your vehicle needs a hand.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/canada-day.mp3', title: 'Home and Open Roads', accent: '#ff4646' },
  },
  thanksgiving: {
    id: 'thanksgiving',
    label: 'Thanksgiving',
    eyebrow: 'Grateful for every neighbour who calls us',
    title: 'Thankful for Richmond, our customers and every mile shared together.',
    description: 'This Thanksgiving, we are celebrating the people who trust us during difficult moments and the community that has supported Jonny’s since the beginning.',
    image: '/images/school-pumpkin-patch.jpg',
    className: 'theme-thanksgiving',
    accentLabel: 'Gratitude in every mile',
    decorations: ['leaves', 'warm-glow'],
    seasonalMessage: {
      icon: '◆',
      title: 'There is a lot to be thankful for.',
      text: 'We are grateful for every review, referral, wave from the roadside and opportunity to make someone’s difficult day a little easier.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/thanksgiving.mp3', title: 'Grateful Miles', accent: '#f1a03d' },
  },
  halloween: {
    id: 'halloween',
    label: 'Halloween',
    eyebrow: '',
    title: 'Something spooky on the roadside? We will make it disappear.',
    description: 'Ghosts, bats and black trucks are welcome this season. Breakdowns are not. Call Jonny’s for professional roadside rescue with a playful Halloween twist.',
    image: '/images/halloween-truck.webp',
    className: 'theme-halloween',
    accentLabel: 'No tricks. Just towing treats.',
    decorations: ['bats', 'fog', 'ghosts', 'moon', 'pumpkins'],
    seasonalMessage: {
      icon: '👻',
      title: 'The Lower Mainland’s most unforgettable roadside experience.',
      text: 'From the truck that arrives to the way we handle the call, Jonny’s is built to deliver a roadside experience unlike anything else in the Lower Mainland.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/halloween.mp3', title: 'Black & Pink After Dark', accent: '#ff8a22' },
  },
  remembrance: {
    id: 'remembrance',
    label: 'Remembrance Day',
    eyebrow: 'We remember',
    title: 'Honouring those who served and sacrificed.',
    description: 'Jonny’s Towing pauses in gratitude and remembrance while remaining available for essential roadside assistance.',
    image: '/images/lions-gate.webp',
    className: 'theme-remembrance',
    accentLabel: 'Lest we forget',
    decorations: ['poppies'],
    seasonalMessage: {
      icon: '●',
      title: 'Lest we forget.',
      text: 'We honour the courage, service and sacrifice of Canada’s veterans and all those who continue to serve.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/remembrance.mp3', title: 'In Quiet Honour', accent: '#ef3038' },
  },
  christmas: {
    id: 'christmas',
    label: 'Christmas',
    eyebrow: 'Richmond’s brightest roadside crew',
    title: 'Snow, lights and a little roadside Christmas magic.',
    description: 'Our decorated holiday trucks are back—bringing professional towing, thoughtful service and a warm Christmas glow to the days that do not go according to plan.',
    image: '/images/christmas-truck.webp',
    className: 'theme-christmas',
    accentLabel: 'Christmas cheer, roadside ready',
    decorations: ['snow', 'lights', 'snowbank', 'sparkles'],
    seasonalMessage: {
      icon: '✦',
      title: 'All is calm. All is bright. Your battery may have other plans.',
      text: 'From jump starts to flatbed towing, Jonny’s is here to help keep your Christmas plans moving—with a little extra holiday cheer along the way.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/christmas.mp3', title: 'Lights Along the Way', accent: '#ff4e62' },
  },
  'new-year': {
    id: 'new-year',
    label: 'New Year',
    eyebrow: 'A fresh year and a clear road ahead',
    title: 'New year. New journeys. The same dependable roadside team.',
    description: 'Wherever the next chapter takes you, Jonny’s Towing is ready to help keep the year moving forward when your vehicle cannot.',
    image: '/images/flatbed-sunset.webp',
    className: 'theme-new-year',
    accentLabel: 'Ready for what comes next',
    decorations: ['confetti', 'fireworks', 'sparkles'],
    seasonalMessage: {
      icon: '✦',
      title: 'Here is to safer roads and better journeys.',
      text: 'Happy New Year from Jonny’s Towing. We are ready for the next call, the next challenge and every mile ahead.',
    },
    music: { src: 'https://iygmzptwotjkftqoreov.supabase.co/storage/v1/object/public/seasonal-audio/v1/new-year.mp3', title: 'The Road Ahead', accent: '#ffd375' },
  },
};

export const THEME_OPTIONS = Object.values(THEMES).map(({ id, label }) => ({ id, label }));
